var map = {
	"./ambassador-bg.webp": 1273,
	"./asset-2.png": 1274,
	"./btn-enter-bg.png": 1275,
	"./btn-enter-white-bg.webp": 1276,
	"./btn-more-bg.webp": 1277,
	"./casino-hover.webp": 1278,
	"./casino.webp": 1279,
	"./convenient.webp": 1280,
	"./es-bg.webp": 1281,
	"./event-sec-bg.webp": 1282,
	"./event-sport-bg.webp": 1283,
	"./fifa1-bg.jpg": 1284,
	"./fifa2-bg-cn.jpg": 1285,
	"./fifa2-bg.jpg": 1286,
	"./games-hover.webp": 1287,
	"./games.webp": 1288,
	"./gauge.webp": 1289,
	"./lottery-hover.webp": 1290,
	"./lottery.webp": 1291,
	"./master-bg.webp": 1292,
	"./p2p-hover.webp": 1293,
	"./p2p.webp": 1294,
	"./platform.webp": 1295,
	"./product-ctg-bg.webp": 1296,
	"./product-overview-bg.webp": 1297,
	"./professional.webp": 1298,
	"./safety.webp": 1299,
	"./slots-hover.webp": 1300,
	"./slots.webp": 1301,
	"./speed.webp": 1302,
	"./sports-hover.webp": 1303,
	"./sports.webp": 1304,
	"./video-bg.webp": 1305,
	"./wave.webp": 1306,
	"./wwr-bg.webp": 1307,
	"./wwr-img-b.webp": 1308,
	"./wwr-img.webp": 1309,
	"./wwr-subImg1.webp": 1310,
	"./wwr-subImg2.webp": 1311,
	"./wwr-subImg3.webp": 1312,
	"./x33-logo-cny.png": 1313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;